var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 0H2.25C1.0125 0 0.01125 1.0125 0.01125 2.25L0 15.75C0 16.9875 1.0125 18 2.25 18H20.25C21.4875 18 22.5 16.9875 22.5 15.75V2.25C22.5 1.0125 21.4875 0 20.25 0ZM19.8 4.78125L11.8462 9.75375C11.4862 9.97875 11.0138 9.97875 10.6538 9.75375L2.7 4.78125C2.58719 4.71793 2.48841 4.63237 2.40962 4.52976C2.33084 4.42715 2.27369 4.30963 2.24165 4.18429C2.2096 4.05896 2.20332 3.92843 2.22318 3.8006C2.24304 3.67276 2.28863 3.55029 2.35719 3.44059C2.42576 3.33089 2.51586 3.23624 2.62207 3.16237C2.72827 3.0885 2.84836 3.03695 2.97506 3.01084C3.10176 2.98472 3.23244 2.98459 3.3592 3.01044C3.48595 3.0363 3.60615 3.0876 3.7125 3.16125L11.25 7.875L18.7875 3.16125C18.8939 3.0876 19.014 3.0363 19.1408 3.01044C19.2676 2.98459 19.3982 2.98472 19.5249 3.01084C19.6516 3.03695 19.7717 3.0885 19.8779 3.16237C19.9841 3.23624 20.0742 3.33089 20.1428 3.44059C20.2114 3.55029 20.257 3.67276 20.2768 3.8006C20.2967 3.92843 20.2904 4.05896 20.2584 4.18429C20.2263 4.30963 20.1692 4.42715 20.0904 4.52976C20.0116 4.63237 19.9128 4.71793 19.8 4.78125Z",
    fill: "#68DE31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.19210f2bff3dae201cb4a44560878c6b.svg";
export { ForwardRef as ReactComponent };